/**
 * Identita' dell'applicazione: unica fonte per footer e modal About.
 * I riferimenti G soLutions sono dati aziendali reali (tenant config Squadron,
 * 2026-06-11) — aggiornare qui se cambiano.
 */
export const APP_NAME = 'VVF Tracking Interventi';

/**
 * Versione/commit/canale iniettati alla build Docker (build-arg → Vite env;
 * vedi apps/web/Dockerfile e version.txt). In dev locale (pnpm dev) le env non
 * esistono → fallback "*-local". MAI hardcodare la versione qui: la decide la
 * build (release da tag, develop/stage con suffisso commit).
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '0.0.0-local';
export const APP_COMMIT = import.meta.env.VITE_APP_COMMIT ?? 'local';
export const APP_CHANNEL = import.meta.env.VITE_APP_CHANNEL ?? 'local';
/** Commit abbreviato per la UI (primi 7 char). */
export const APP_COMMIT_SHORT = APP_COMMIT.slice(0, 7);

export const DEVELOPER = {
  name: 'G soLutions',
  legalName: 'G soLutions di Luzu Gabriele',
  owner: 'Gabriele Luzu',
  ownerRole: 'Software Architect & IT Consultant',
  tagline: 'Trasforma le tue idee in soluzioni digitali',
  website: 'https://gsolutions-it.com',
  email: 'software@gsolutions-it.com',
  phone: '+39 340 4737889',
  vatNumber: '04227230366',
  city: 'Formigine (MO)',
} as const;
